import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, take} from 'rxjs';
import {environment} from "@env/environment";

export interface User {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    profile: string;
    status: string;
}

export interface LoginResponse {
    data: {
        accessToken: string;
        refreshToken: string;
        tokenType: string;
        expiresIn: number;
        user: User;
    };
    success: boolean;
}

export interface RefreshTokenResponse {
    data: {
        accessToken: string;
        refreshToken: string;
        tokenType: string;
        expiresIn: number;
    };
    success: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class AuthApiService {
    private http = inject(HttpClient);
    private readonly apiServiceUrl = environment.serviceApi;

    login(email: string, password: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(`${this.apiServiceUrl}/v1/auth/login`, {email, password})
            .pipe(take(1));
    }

    refreshToken(refreshToken: string): Observable<RefreshTokenResponse> {
        return this.http.post<RefreshTokenResponse>(`${this.apiServiceUrl}/v1/auth/refresh`, {refreshToken})
            .pipe(take(1));
    }

    changePassword(id: number, password: string): Observable<any> {
        return this.http.post(`${this.apiServiceUrl}/v1/auth/users/${id}/change-password`, {newPassword: password})
            .pipe(take(1));
    }

}

